import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList
} from "recharts";

const redColor = "#f87171";
const greenColor = "#34d399";
const blueColor = "#007BFF";

export default function RecuperationChart({ data }) {
  const cardStyles = { padding: '12px', backgroundColor: '#fff', borderRadius: '2px', border: '1px solid #f1f1f1' };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload?.length) {
      return (
        <div style={cardStyles}>
          <p style={{ fontWeight: 'bolder' }}>{label}</p>
          <p style={{ color: redColor }}>En partance: {payload[0].value}</p>
          <p style={{ color: greenColor }}>Récupérés: {payload[1].value}</p>
          <p style={{ color: blueColor }}>Taux: {payload[2].value.toFixed(0)}%</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={450}>
      <ComposedChart
        data={data}
        margin={{ top: 20, right: 40, left: 20, bottom: 50 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="month"
          interval={0}
          angle={-30}
          textAnchor="end"
        />
        <YAxis
          yAxisId="left"
          label={{
            value: "Nombre de clients",
            angle: -90,
            position: "insideLeft"
          }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          domain={[0, 100]}
          label={{
            value: "Taux de récupération (%)",
            angle: -90,
            position: "insideRight"
          }}
        />

        <Bar
          yAxisId="left"
          dataKey="old"
          fill={redColor}
          name="Clients en partance"
          radius={[10, 10, 0, 0]}
        />
        <Bar
          yAxisId="left"
          dataKey="recovered"
          fill={greenColor}
          name="Clients récupérés"
          radius={[10, 10, 0, 0]}
        />

        <Line
          yAxisId="right"
          type="monotone"
          dataKey="ratio"
          stroke={blueColor}
          strokeWidth={2}
          name="Taux de récupération (%)"
          dot={{ r: 3 }}
          activeDot={{ r: 4 }}
        >
          <LabelList
            position="top"
            fill={blueColor}
            fontSize="10"
            formatter={(value) => value.toFixed(0) + '%'}
          />
        </Line>

        <Tooltip content={<CustomTooltip />} />
        <Legend verticalAlign="bottom" wrapperStyle={{ bottom: '40px' }} height={36} style={{ marginTop: '40px'}} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
